
// // src/pages/Employee/CreateEmployee/steps/Step1BasicInfo.tsx
// import React, { useState, useEffect, useCallback } from 'react';
// import { Row, Col, FormGroup, Label, Input, FormFeedback, Spinner } from 'reactstrap';
// import { BasicInfoData, StepProps } from '../../types/employee.types';
// import { apiClient } from '../../helpers/api_helper';
// import { updateEmployeeCodeValidation, resetEmployeeCodeValidation } from '../../types/validator';

// const Step1BasicInfo: React.FC<StepProps<BasicInfoData>> = ({ 
//   data, 
//   onChange, 
//   errors 
// }) => {
//   const [isChecking, setIsChecking] = useState(false);
//   const [codeAvailable, setCodeAvailable] = useState<boolean | null>(null);
//   const [codeError, setCodeError] = useState<string | null>(null);
//   const [debounceTimer, setDebounceTimer] = useState<NodeJS.Timeout | null>(null);

//   const set = (field: keyof BasicInfoData, value: string) => {
//     onChange({ ...data, [field]: value });
//   };

//   // Check if employee code exists
//   const checkEmployeeCode = useCallback(async (code: string) => {
//     if (!code || code.trim() === '') {
//       setCodeAvailable(null);
//       setCodeError(null);
//       // Update validator state
//       updateEmployeeCodeValidation(false, true, null);
//       return;
//     }

//     setIsChecking(true);
//     setCodeError(null);
//     // Update validator state - checking
//     updateEmployeeCodeValidation(true, true, null);

//     try {
//       const response = await apiClient.get(`/employees/check-code?code=${code.trim()}`);
//       const result = response.data;
//       console.log("data",result)
//       if (result.exists) {
//         const exists = result.exists;
//         setCodeAvailable(!exists);
        
//         if (exists) {
//           const errorMsg = `Employee code "${code}" is already in use${result.employee ? ` by ${result.employee.name}` : ''}`;
//           setCodeError(errorMsg);
//           // Update validator state - not available
//           updateEmployeeCodeValidation(false, false, errorMsg);
//         } else {
//           setCodeError(null);
//           // Update validator state - available
//           updateEmployeeCodeValidation(false, true, null);
//         }
//       }
//     } catch (error: any) {
//       console.error('Error checking employee code:', error);
//       const errorMsg = 'Failed to verify employee code. Please try again.';
//       setCodeError(errorMsg);
//       // Update validator state - error
//       updateEmployeeCodeValidation(false, false, errorMsg);
//     } finally {
//       setIsChecking(false);
//     }
//   }, []);

//   // Handle employee code change with debouncing
//   const handleCodeChange = (value: string) => {
//     // Only allow numbers
//     const numericValue = value.replace(/\D/g, '');
//     set('employee_code', numericValue);

//     // Clear previous timer
//     if (debounceTimer) {
//       clearTimeout(debounceTimer);
//     }

//     // Reset availability status
//     setCodeAvailable(null);
//     setCodeError(null);
//     // Reset validator state
//     resetEmployeeCodeValidation();

//     // Set new timer for API call (500ms delay)
//     if (numericValue.length >= 2) { // Only check if at least 2 digits
//       const timer = setTimeout(() => {
//         checkEmployeeCode(numericValue);
//       }, 500);
//       setDebounceTimer(timer);
//     } else {
//       // Update validator state - no code to check, but field might be empty
//       updateEmployeeCodeValidation(false, true, null);
//     }
//   };

//   // Cleanup timer on unmount
//   useEffect(() => {
//     return () => {
//       if (debounceTimer) {
//         clearTimeout(debounceTimer);
//       }
//       // Reset validation state on unmount
//       resetEmployeeCodeValidation();
//     };
//   }, [debounceTimer]);

//   return (
//     <div>
//       <h6 className="mb-3">Basic Information</h6>
//       <Row>
//         <Col md={4}>
//           <FormGroup>
//             <Label className="fw-bold text-muted small text-uppercase">
//               Full Name <span className="text-danger">*</span>
//             </Label>
//             <Input
//               value={data.name}
//               invalid={!!errors.name}
//               onChange={(e) => set('name', e.target.value)}
//               placeholder="e.g. Arun Kumar"
//             />
//             <FormFeedback>{errors.name}</FormFeedback>
//           </FormGroup>
//         </Col>
//         <Col md={4}>
//           <FormGroup>
//             <Label className="fw-bold text-muted small text-uppercase">
//               Employee Code <span className="text-danger">*</span>
//             </Label>
//             <Input
//               value={data.employee_code}
//               invalid={!!errors.employee_code || !!codeError || codeAvailable === false}
//               valid={codeAvailable === true && data.employee_code.length > 0}
//               onChange={(e) => handleCodeChange(e.target.value)}
//               placeholder="e.g. 0245"
//               type="text"
//               inputMode="numeric"
//               pattern="[0-9]*"
//             />
//             <div className="d-flex align-items-center mt-1">
//               {isChecking && (
//                 <span className="text-muted small">
//                   <Spinner size="sm" className="me-1" />
//                   Checking availability...
//                 </span>
//               )}
//               {!isChecking && codeAvailable === true && data.employee_code.length > 0 && (
//                 <span className="text-success small">
//                   ✓ Code available
//                 </span>
//               )}
//               {!isChecking && codeAvailable === false && codeError && (
//                 <span className="text-danger small">
//                   ✗ {codeError}
//                 </span>
//               )}
//               {!isChecking && !codeAvailable && data.employee_code.length > 0 && !codeError && (
//                 <span className="text-muted small">Enter at least 2 digits to check</span>
//               )}
//             </div>
//             <FormFeedback>{errors.employee_code}</FormFeedback>
//           </FormGroup>
//         </Col>
//         <Col md={4}>
//           <FormGroup>
//             <Label className="fw-bold text-muted small text-uppercase">Gender</Label>
//             <Input type="select" value={data.gender} onChange={(e) => set('gender', e.target.value)}>
//               <option value="">Select...</option>
//               <option value="male">Male</option>
//               <option value="female">Female</option>
//               <option value="other">Other</option>
//             </Input>
//           </FormGroup>
//         </Col>
//       </Row>

//       <Row>
//         <Col md={4}>
//           <FormGroup>
//             <Label className="fw-bold text-muted small text-uppercase">Father's Name</Label>
//             <Input value={data.father_name} onChange={(e) => set('father_name', e.target.value)} />
//           </FormGroup>
//         </Col>
//         <Col md={4}>
//           <FormGroup>
//             <Label className="fw-bold text-muted small text-uppercase">Mother's Name</Label>
//             <Input value={data.mother_name} onChange={(e) => set('mother_name', e.target.value)} />
//           </FormGroup>
//         </Col>
//         <Col md={4}>
//           <FormGroup>
//             <Label className="fw-bold text-muted small text-uppercase">Date of Birth</Label>
//             <Input
//               type="date"
//               value={data.date_of_birth}
//               onChange={(e) => set('date_of_birth', e.target.value)}
//             />
//           </FormGroup>
//         </Col>
//       </Row>

//       <Row>
//         <Col md={4}>
//           <FormGroup>
//             <Label className="fw-bold text-muted small text-uppercase">
//               Phone <span className="text-danger">*</span>
//             </Label>
//             <Input
//               value={data.phone}
//               invalid={!!errors.phone}
//               onChange={(e) => set('phone', e.target.value.replace(/[^\d+]/g, ''))}
//               placeholder="10-digit mobile number"
//             />
//             <FormFeedback>{errors.phone}</FormFeedback>
//           </FormGroup>
//         </Col>
//         <Col md={4}>
//           <FormGroup>
//             <Label className="fw-bold text-muted small text-uppercase">Alternate Phone</Label>
//             <Input
//               value={data.phone_alternate}
//               onChange={(e) => set('phone_alternate', e.target.value.replace(/[^\d+]/g, ''))}
//             />
//           </FormGroup>
//         </Col>
//         <Col md={4}>
//           <FormGroup>
//             <Label className="fw-bold text-muted small text-uppercase">Aadhar Number</Label>
//             <Input
//               value={data.aadharr}
//               invalid={!!errors.aadharr}
//               maxLength={12}
//               onChange={(e) => set('aadharr', e.target.value.replace(/\D/g, ''))}
//               placeholder="12-digit Aadhar number"
//             />
//             <FormFeedback>{errors.aadharr}</FormFeedback>
//           </FormGroup>
//         </Col>
//       </Row>

//       <Row>
//         <Col md={6}>
//           <FormGroup>
//             <Label className="fw-bold text-muted small text-uppercase">Personal Email</Label>
//             <Input
//               type="email"
//               value={data.personal_email}
//               invalid={!!errors.personal_email}
//               onChange={(e) => set('personal_email', e.target.value)}
//             />
//             <FormFeedback>{errors.personal_email}</FormFeedback>
//           </FormGroup>
//         </Col>
//         <Col md={6}>
//           <FormGroup>
//             <Label className="fw-bold text-muted small text-uppercase">Official Email</Label>
//             <Input
//               type="email"
//               value={data.official_email}
//               invalid={!!errors.official_email}
//               onChange={(e) => set('official_email', e.target.value)}
//             />
//             <FormFeedback>{errors.official_email}</FormFeedback>
//           </FormGroup>
//         </Col>
//       </Row>
//     </div>
//   );
// };

// export default Step1BasicInfo;

// src/pages/Employee/CreateEmployee/steps/Step1BasicInfo.tsx

import React, { useState, useEffect, useCallback, useRef } from 'react';
import { Row, Col, FormGroup, Label, Input, FormFeedback, Spinner } from 'reactstrap';
import { BasicInfoData, StepProps } from '../../types/employee.types';
import { apiClient } from '../../helpers/api_helper';
import { updateEmployeeCodeValidation, resetEmployeeCodeValidation } from '../../types/validator';

const Step1BasicInfo: React.FC<StepProps<BasicInfoData>> = ({ 
  data, 
  onChange, 
  errors 
}) => {
  const [isChecking, setIsChecking] = useState(false);
  const [codeAvailable, setCodeAvailable] = useState<boolean | null>(null);
  const [codeError, setCodeError] = useState<string | null>(null);
  const [hasChecked, setHasChecked] = useState(false);
  const inputRef = useRef<any>(null);

  const set = (field: keyof BasicInfoData, value: string) => {
    onChange({ ...data, [field]: value });
  };

  // Check if employee code exists - Called only on blur
  const checkEmployeeCode = useCallback(async (code: string) => {
    if (!code || code.trim() === '') {
      setCodeAvailable(null);
      setCodeError(null);
      setHasChecked(false);
      updateEmployeeCodeValidation(false, true, null);
      return;
    }

    setIsChecking(true);
    setCodeError(null);
    setHasChecked(true);
    updateEmployeeCodeValidation(true, true, null);

    try {
      const response = await apiClient.get(`/employees/check-code?code=${encodeURIComponent(code.trim())}`);
      const result = response.data;
      console.log("data", result);
      
      const exists = result.exists || false;
      setCodeAvailable(!exists);
      
      if (exists) {
        const errorMsg = `Employee code "${code}" is already in use${result.employee ? ` by ${result.employee.name}` : ''}`;
        setCodeError(errorMsg);
        updateEmployeeCodeValidation(false, false, errorMsg);
      } else {
        setCodeError(null);
        updateEmployeeCodeValidation(false, true, null);
      }
    } catch (error: any) {
      console.error('Error checking employee code:', error);
      const errorMsg = 'Failed to verify employee code. Please try again.';
      setCodeError(errorMsg);
      updateEmployeeCodeValidation(false, false, errorMsg);
    } finally {
      setIsChecking(false);
    }
  }, []);

  // Handle employee code change - Auto uppercase for letters
  const handleCodeChange = (value: string) => {
    // ✅ Allow alphanumeric and convert letters to uppercase
    const alphanumericValue = value.replace(/[^a-zA-Z0-9]/g, '').toUpperCase();
    set('employee_code', alphanumericValue);
    
    // Reset validation state when user types
    setCodeAvailable(null);
    setCodeError(null);
    setHasChecked(false);
    resetEmployeeCodeValidation();
  };

  // Handle blur event - API call happens here
  const handleBlur = () => {
    if (data.employee_code && data.employee_code.length >= 2) {
      checkEmployeeCode(data.employee_code);
    }
  };

  // Handle Enter key press - trigger check
  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      if (data.employee_code && data.employee_code.length >= 2) {
        checkEmployeeCode(data.employee_code);
      }
    }
  };

  // Cleanup on unmount
  useEffect(() => {
    return () => {
      resetEmployeeCodeValidation();
    };
  }, []);

  // Determine if we should show validation states
  const showError = (!!errors.employee_code || !!codeError || codeAvailable === false) && (hasChecked || data.employee_code.length > 0);
  const showSuccess = codeAvailable === true && data.employee_code.length > 0 && hasChecked;

  return (
    <div>
      <h6 className="mb-3">Basic Information</h6>
      <Row>
        <Col md={4}>
          <FormGroup>
            <Label className="fw-bold text-muted small text-uppercase">
              Full Name <span className="text-danger">*</span>
            </Label>
            <Input
              value={data.name}
              invalid={!!errors.name}
              onChange={(e) => set('name', e.target.value)}
              placeholder="e.g. Arun Kumar"
            />
            <FormFeedback>{errors.name}</FormFeedback>
          </FormGroup>
        </Col>
        <Col md={4}>
          <FormGroup>
            <Label className="fw-bold text-muted small text-uppercase">
              Employee Code <span className="text-danger">*</span>
            </Label>
            <Input
              ref={inputRef}
              value={data.employee_code}
              invalid={showError}
              valid={showSuccess}
              onChange={(e) => handleCodeChange(e.target.value)}
              onBlur={handleBlur}
              onKeyDown={handleKeyDown}
              placeholder="e.g. EMP001 or 0245"
              type="text"
              style={{ textTransform: 'uppercase' }}
            />
            <div className="d-flex align-items-center mt-1">
              {isChecking && (
                <span className="text-muted small">
                  <Spinner size="sm" className="me-1" />
                  Checking availability...
                </span>
              )}
              {!isChecking && showSuccess && (
                <span className="text-success small">
                  ✓ Code available
                </span>
              )}
              {!isChecking && showError && codeError && (
                <span className="text-danger small">
                  ✗ {codeError}
                </span>
              )}
              {!isChecking && !codeAvailable && data.employee_code.length > 0 && !codeError && !isChecking && data.employee_code.length < 2 && (
                <span className="text-muted small">Enter at least 2 characters</span>
              )}
              {!isChecking && !codeAvailable && data.employee_code.length > 0 && !codeError && !isChecking && data.employee_code.length >= 2 && !hasChecked && (
                <span className="text-muted small">Press Enter or click outside to check</span>
              )}
            </div>
            <FormFeedback>{errors.employee_code}</FormFeedback>
          </FormGroup>
        </Col>
        <Col md={4}>
          <FormGroup>
            <Label className="fw-bold text-muted small text-uppercase">Gender</Label>
            <Input type="select" value={data.gender} onChange={(e) => set('gender', e.target.value)}>
              <option value="">Select...</option>
              <option value="male">Male</option>
              <option value="female">Female</option>
              <option value="other">Other</option>
            </Input>
          </FormGroup>
        </Col>
      </Row>

      <Row>
        <Col md={4}>
          <FormGroup>
            <Label className="fw-bold text-muted small text-uppercase">Father's Name</Label>
            <Input value={data.father_name} onChange={(e) => set('father_name', e.target.value)} />
          </FormGroup>
        </Col>
        <Col md={4}>
          <FormGroup>
            <Label className="fw-bold text-muted small text-uppercase">Mother's Name</Label>
            <Input value={data.mother_name} onChange={(e) => set('mother_name', e.target.value)} />
          </FormGroup>
        </Col>
        <Col md={4}>
          <FormGroup>
            <Label className="fw-bold text-muted small text-uppercase">Date of Birth</Label>
            <Input
              type="date"
              value={data.date_of_birth}
              onChange={(e) => set('date_of_birth', e.target.value)}
            />
          </FormGroup>
        </Col>
      </Row>

      <Row>
        <Col md={4}>
          <FormGroup>
            <Label className="fw-bold text-muted small text-uppercase">
              Phone <span className="text-danger">*</span>
            </Label>
            <Input
              value={data.phone}
              invalid={!!errors.phone}
              onChange={(e) => set('phone', e.target.value.replace(/[^\d+]/g, ''))}
              placeholder="10-digit mobile number"
            />
            <FormFeedback>{errors.phone}</FormFeedback>
          </FormGroup>
        </Col>
        <Col md={4}>
          <FormGroup>
            <Label className="fw-bold text-muted small text-uppercase">Alternate Phone</Label>
            <Input
              value={data.phone_alternate}
              onChange={(e) => set('phone_alternate', e.target.value.replace(/[^\d+]/g, ''))}
            />
          </FormGroup>
        </Col>
        <Col md={4}>
          <FormGroup>
            <Label className="fw-bold text-muted small text-uppercase">Aadhar Number</Label>
            <Input
              value={data.aadharr}
              invalid={!!errors.aadharr}
              maxLength={12}
              onChange={(e) => set('aadharr', e.target.value.replace(/\D/g, ''))}
              placeholder="12-digit Aadhar number"
            />
            <FormFeedback>{errors.aadharr}</FormFeedback>
          </FormGroup>
        </Col>
      </Row>

      <Row>
        <Col md={6}>
          <FormGroup>
            <Label className="fw-bold text-muted small text-uppercase">Personal Email</Label>
            <Input
              type="email"
              value={data.personal_email}
              invalid={!!errors.personal_email}
              onChange={(e) => set('personal_email', e.target.value)}
            />
            <FormFeedback>{errors.personal_email}</FormFeedback>
          </FormGroup>
        </Col>
        <Col md={6}>
          <FormGroup>
            <Label className="fw-bold text-muted small text-uppercase">Official Email</Label>
            <Input
              type="email"
              value={data.official_email}
              invalid={!!errors.official_email}
              onChange={(e) => set('official_email', e.target.value)}
            />
            <FormFeedback>{errors.official_email}</FormFeedback>
          </FormGroup>
        </Col>
      </Row>
    </div>
  );
};

export default Step1BasicInfo;